/**
 * Extracts the invite token from an `/invite/:token` pathname. Pure function (no DOM) so
 * it's trivially unit-testable; `RegisterPage` falls back to `window.location.pathname`
 * when no `token` prop is supplied, so it works standalone today and can take a route
 * param from whichever router WS-3 picks later without changing this contract.
 */
export function extractInviteToken(pathname: string): string | null {
  const match = /^\/invite\/([^/]+)\/?$/.exec(pathname);
  const token = match?.[1];
  return token ? decodeURIComponent(token) : null;
}
